// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_PixResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/pix/{id}
 *
 * Returns the PIX QR code payload for a payment link. Shape comes from the
 * provider (encodedImage + payload, plus any extra provider-specific fields)
 * and is owned downstream.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_PixResponseDados = unknown[];

export type SubaccountsLinks_PixResponse = ApiResponse<SubaccountsLinks_PixResponseDados>;

registerResponseContract('SubaccountsLinks_PixResponse', {})
